module.exports = __webpack_public_path__ + "static/media/Twitter.a08b49ea.svg";